import $ from 'init/jquery'
import { Defaults } from 'es-decorators'
import { View } from 'es6/components/view'
import { Model } from 'es6/components/model'
import isFunction from 'lodash/isFunction'

/**
 * Лоадер.
 *
 * @param {jQuery} contentWrapper - внутри него отрисуется лоадер
 * @param {boolean} withFade - отрисовка с засветлением бэкграунда.
 * @param {app.MainWindow} mainWindow - представление окна браузера.
 * @param {string} sizeClass - название css класса со стилями размеров лоадера.
 * @param {boolean} [invisibleLoader] - признак, что лоадер скрывается, а не удаляется.
 */
@Defaults({
  // Минимальная высота для лоадера.
  LOADER_MIN_HEIGHT: 32,
  contentWrapper: null,
  sizeClass: 'medium',
  loaderClass: 'preloader-ring',
  faderClass: 'preloader-back',
  isWhite: false,
  invisibleLoader: false,
  additionalOptions: [
    'contentWrapper',
    'withFade',
    'mainWindow',
    'sizeClass',
    'loaderClass',
    'faderClass',
    'isWhite',
    'invisibleLoader',
  ],
})
export class LoaderView extends View {
  /** @inheritDoc */
  run () {
    this.model = new Model({
      isActivePreloader: false,
    })

    const loaderClasses = [this.loaderClass, this.sizeClass]
    if (this.isWhite) {
      loaderClasses.push('preloader-white')
    }
    this.$loader = $(document.createElement('div')).addClass(loaderClasses)
    if (this.withFade) {
      const faderClasses = [this.faderClass]
      if (this.isWhite) {
        faderClasses.push('preloader-back-white')
      }
      this.$fader = $(document.createElement('div')).addClass(faderClasses)
    }
  }

  /**
   * Рендер элементов лоадера и фэйдера
   */
  render () {
    if (!this.model.get('isActivePreloader')) {
      let wrapper = this.contentWrapper || 'body'
      if (this.$fader) {
        let existingFader = $(wrapper).find('.' + this.faderClass)
        if (existingFader.length) {
          this.$fader = existingFader
        } else {
          this.$fader
            .removeClass('not_display')
            .appendTo(wrapper)
        }
      }
      const hasContentWrapper = this.contentWrapper
        && isFunction(this.contentWrapper.height)
        && this.contentWrapper.height() > this.LOADER_MIN_HEIGHT
      wrapper = hasContentWrapper ? this.contentWrapper : 'body'
      let existingLoader = $(wrapper).find('.' + this.loaderClass)
      if (existingLoader.length) {
        this.$loader = existingLoader
        this.$loader.removeClass('preloader-hidden')
      } else {
        this.$loader.css({
          top: this.calculateLoaderTopPosition(hasContentWrapper),
        })
        this.$loader.appendTo(wrapper)
      }
      this.model.set('isActivePreloader', true)
    }
  }

  /**
   * Рассчитывает top позицию лоадера, по центру относительно родителя
   * @param {boolean} hasContentWrapper - есть ли контейнер для лоадера
   * @returns {number} - позиция в px
   */
  calculateLoaderTopPosition (hasContentWrapper) {
    let elementTop = 0
    const windowHeight = (this.mainWindow && this.mainWindow.getHeight()) || 0
    const windowScrollTop = (this.mainWindow && this.mainWindow.getScrollTop()) || 0

    if (hasContentWrapper) {
      let wrapperTopOffset = 0
      if (isFunction(this.contentWrapper.offset)) {
        let wrapperOffset = this.contentWrapper.offset()
        wrapperTopOffset = wrapperOffset ? wrapperOffset.top : wrapperTopOffset
      }

      let wrapperHeight = 0
      if (isFunction(this.contentWrapper.outerHeight)) {
        wrapperHeight = this.contentWrapper.outerHeight()
      }
      if (wrapperHeight > windowHeight) {
        elementTop = Math.floor((windowScrollTop + windowHeight - wrapperTopOffset) / 2)
        if (elementTop < 0) {
          elementTop = this.LOADER_MIN_HEIGHT
        }
      } else {
        elementTop = Math.floor(wrapperHeight / 2)
      }
    } else {
      elementTop = Math.floor(windowScrollTop + windowHeight / 2)
    }

    return elementTop
  }

  /**
   * Удаляет отрендеренные элементы со страницы
   */
  remove () {
    this.model.set('isActivePreloader', false)
    if (this.invisibleLoader) {
      this.$loader && this.$loader.addClass('preloader-hidden')
    } else {
      this.$loader && this.$loader.remove()
    }
    this.$fader && this.$fader.remove()
  }
}
